export class Payment {
  // NOTE: クエリの取得制限で最大100件となる。ページ等は実装してなく修正の必要があれば対応
  public static readonly MAX_ITEM_NUMBER = 100;
}
